export default __webpack_public_path__ + "static/ruinedKingHeroChar-a3200ac16dc9535bfe60d0773972b776.png";